// extracted by mini-css-extract-plugin
export default {"overlay":"LoadingOverlay_overlay__zy4sv","show":"LoadingOverlay_show__brGXP","text":"LoadingOverlay_text__K-+X-"};